import { Link, Module } from '@billy/design-system'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getPostalAddress } from '@features/contacts/utils/getPostalAddress'

import { useContactDetail } from '../../contexts/contactDetailContext'
import { ClientInformationEmptyState } from './elements/ClientInformationEmptyState'
import { ClientInformationOptionalFields } from './elements/ClientInformationOptionalFields'
import { ClientInformationPrimaryFields } from './elements/ClientInformationPrimaryFields'
import { getDeliveryAddress } from './utils/getDeliveryAddress'

export const ClientInformation = () => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)
  const { contact, shippingAddress } = useContactDetail()

  const postalAddress = getPostalAddress(contact)
  const deliveryAddress = getDeliveryAddress(shippingAddress)

  const hasPrimaryFields = !!(contact.registrationNo || postalAddress || deliveryAddress || contact.phone)

  const hasOptionalFields = !!(
    contact.vatNo ||
    contact.ean ||
    contact.paymentTermsDays != null ||
    contact.currencyId ||
    contact.invoicingLanguage
  )

  const hasAnyFields = hasPrimaryFields || hasOptionalFields
  const showOptionalOnly = !hasPrimaryFields && hasOptionalFields
  const showExpandableOptional = hasPrimaryFields && hasOptionalFields

  if (!hasAnyFields) {
    return <ClientInformationEmptyState />
  }

  const handleLinkClick = () => setIsExpanded((prev) => !prev)

  return (
    <Module>
      <Module.SectionsGroup>
        <Module.Section>
          {showOptionalOnly ? (
            <ClientInformationOptionalFields contact={contact} />
          ) : (
            <ClientInformationPrimaryFields
              contact={contact}
              deliveryAddress={deliveryAddress}
              postalAddress={postalAddress}
            />
          )}
        </Module.Section>

        {showExpandableOptional && isExpanded && (
          <Module.Section>
            <ClientInformationOptionalFields contact={contact} />
          </Module.Section>
        )}

        {showExpandableOptional && (
          <Module.Section>
            <Link onClick={handleLinkClick}>
              {isExpanded ? t('contact.detail.show_less') : t('contact.detail.show_more')}
            </Link>
          </Module.Section>
        )}
      </Module.SectionsGroup>
    </Module>
  )
}
